module.exports = __webpack_public_path__ + "static/media/profile-2.3329e596.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/website-bot/img/profile-2.webp
// module id = 435
// module chunks = 0